import { CoreTrendsBarCellWrapper } from "pro-features/components/core cells/src/CoreTrendsBarCell/CoreTrendsBarCellWrapper";
import {
    ChangePercentage,
    DefaultCellRightAlign,
    IndexCell,
    LeadingSite,
    SearchKeywordCell,
    TrafficShareWithVisits,
} from "app/components/React/Table/cells";
import { RowSelectionConsumer } from "app/components/React/Table/cells/RowSelection";
import { DefaultCellHeader, DefaultCellHeaderRightAlign } from "app/components/React/Table/headerCells";
import { SelectAllRowsHeaderCellConsumer } from "app/components/React/Table/headerCells/SelectAllRowsHeaderCell";
import { i18nFilter } from "app/filters/i18nFilter";
import { proNavigator } from "single-spa/react-app/ProNavigator";

const DEFAULT_SORT_FIELD = "TotalShare";
const DEFAULT_SORT_DIRECTION = "desc";

export const DesktopMobileShare = "DesktopMobileShare";

export const getColumns = (
    excludedColumns = new Set<string>(),
    sortedColumn = { field: DEFAULT_SORT_FIELD, sortDirection: DEFAULT_SORT_DIRECTION },
) => {
    const pageParams = proNavigator.getParams();
    const i18n = i18nFilter();
    const columns = [
        {
            fixed: true,
            cellComponent: RowSelectionConsumer,
            headerComponent: SelectAllRowsHeaderCellConsumer,
            sortable: false,
            width: 40,
            dashboardHide: true,
            disableHeaderCellHover: true,
        },
        {
            fixed: true,
            cellComponent: IndexCell,
            sortable: false,
            width: 52,
            dashboardHide: "true",
            disableHeaderCellHover: true,
        },
        {
            field: "SearchTerm",
            minWidth: 200,
            sortable: true,
            showTotalCount: true,
            displayName: i18n("ia.topkeywords.table.column.searchTerm"),
            tooltip: i18n("analysis.source.search.all.table.columns.searchterms.title.tooltip"),
            isResizable: true,
            cellComponent: (props) => (
                <SearchKeywordCell
                    {...props}
                    withAdsLink={false}
                    destinationState={"organicsearch_keywordAnalysis_overview_2"}
                    navigatorParams={{ ...pageParams }}
                />
            ),
        },
        {
            field: "TotalShare",
            displayName: i18n("ia.topkeywords.table.column.trafficShareWithVisits"),
            sortable: true,
            groupable: false,
            isResizable: true,
            cellComponent: (props) => (
                <TrafficShareWithVisits
                    {...props}
                    totalVisitsRowProp={"Visits"}
                />
            ),
            tooltip: i18n("ia.topkeywords.table.column.trafficShareWithVisits.tooltip"),
            width: 158,
        },
        {
            field: "Change",
            displayName: i18n("analysis.source.search.all.table.columns.change.title"),
            sortable: true,
            groupable: false,
            cellComponent: ChangePercentage,
            tooltip: "widget.table.tooltip.topsites.change",
            width: 95,
            isResizable: true,
        },
        {
            field: "Volume",
            displayName: i18n("ia.topkeywords.table.column.volume"),
            tooltip: i18n("widget.table.tooltip.searchkeywordsabb.volume"),
            sortable: false,
            groupable: false,
            cellComponent: DefaultCellRightAlign,
            headerComponent: DefaultCellHeaderRightAlign,
            width: 81,
            isResizable: true,
            format: "minAbbrNumber",
        },
        {
            field: "VolumeTrend",
            displayName: i18n("ia.topkeywords.table.column.yearlyTrend"),
            tooltip: i18n("widget.table.tooltip.searchkeywordsabb.volume.trend"),
            sortable: false,
            groupable: false,
            cellComponent: CoreTrendsBarCellWrapper,
            headerComponent: DefaultCellHeaderRightAlign,
            width: 130,
            isResizable: true,
        },
        {
            field: "LeadingSite",
            displayName: i18n("keywords.seasonality.table.leader.name"),
            tooltip: i18n("keywords.seasonality.table.leader.name.tooltip"),
            sortable: false,
            groupable: false,
            cellComponent: LeadingSite,
            headerComponent: DefaultCellHeader,
            width: 150,
            isResizable: true,
        },
    ].map((col) => {
        const isSorted = sortedColumn && col.field === sortedColumn.field;
        return {
            ...col,
            visible: !excludedColumns.has(col.field),
            sortDirection: isSorted ? sortedColumn.sortDirection : DEFAULT_SORT_DIRECTION,
        };
    });
    return columns;
};
